export enum BugsnagSeveritiesEnum {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}
